class CustomerReviews extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // 1. Filter tags toggle
    const filterTags = this.querySelectorAll('.cr-filters__tag');
    filterTags.forEach(tag => {
      tag.addEventListener('click', () => {
        // Toggle active class on click
        filterTags.forEach(t => t.classList.remove('cr-filters__tag--active'));
        tag.classList.add('cr-filters__tag--active');
      });
    });

    // 2. Helpful button toggle
    const helpfulBtns = this.querySelectorAll('.cr-list__helpful-btn');
    helpfulBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        btn.classList.toggle('is-active');
        const textSpan = btn.nextElementSibling;
        if (textSpan && btn.classList.contains('is-active')) {
          btn.style.color = 'var(--cr-star)';
        } else {
          btn.style.color = '#999';
        }
      });
    });

    // 3. Image Modal (Lightbox)
    const reviewThumbs = this.querySelectorAll('.cr-list__thumb, .cr-previews__img-wrap');
    const imageModal = this.querySelector('#cr-image-modal');
    const imageModalImg = this.querySelector('#cr-image-modal-img');
    const imageModalClose = this.querySelector('.cr-modal__close[data-target="image-modal"]');

    if (imageModal && imageModalImg) {
      reviewThumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const img = thumb.querySelector('img');
          if (img) {
            imageModalImg.src = img.src;
            imageModal.classList.add('is-open');
            document.body.style.overflow = 'hidden'; // prevent scroll
          }
        });
      });

      imageModalClose.addEventListener('click', () => {
        imageModal.classList.remove('is-open');
        document.body.style.overflow = '';
      });

      // Close on backdrop click
      imageModal.addEventListener('click', (e) => {
        if (e.target === imageModal) {
          imageModal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }

    // 4. View More Reviews Modal
    const viewMoreBtns = this.querySelectorAll('.cr-view-more__btn, .cr-previews__mask');
    const reviewsModal = this.querySelector('#cr-reviews-modal');
    const reviewsModalClose = this.querySelector('.cr-modal__close[data-target="reviews-modal"]');

    if (reviewsModal) {
      viewMoreBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          reviewsModal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      reviewsModalClose.addEventListener('click', () => {
        reviewsModal.classList.remove('is-open');
        document.body.style.overflow = '';
      });

      // Close on backdrop click
      reviewsModal.addEventListener('click', (e) => {
        if (e.target === reviewsModal) {
          reviewsModal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  }
}

customElements.define('customer-reviews', CustomerReviews);
